import { Button, Col, Form, Offcanvas, Row } from "react-bootstrap";
import TextEditor from "../TextEditor";

function ServicesSection({
  show,
  hide,
  index,
  setIndex,
  sectionData,
  setSectionData,
  setServices,
  mode,
  setMode,
}) {
  const handleSubmit = () => {
    if (mode === "add") {
      setServices((prev) => [...prev, sectionData]);
    } else {
      setServices((prev) =>
        prev.map((item, i) => (i === index ? sectionData : item)),
      );
    }
    hide();
    setIndex(null);
    setMode("");
    setSectionData("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditorChange = (value, name) => {
    setSectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {mode === "add" ? "Add New Service" : `Service ${index + 1}`}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-2">
              <Form.Label>Title</Form.Label>
              <Form.Control
                placeholder="Enter Title"
                type="text"
                name="title"
                value={sectionData?.title}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-2">
              <Form.Label>Short Description</Form.Label>
              <Form.Control
                as="textarea"
                row={3}
                placeholder="Enter Short Description"
                name="shortDescription"
                value={sectionData?.shortDescription}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Label>Long Description</Form.Label>
              <TextEditor
                placeholder={"Write Service Details..."}
                editorContent={sectionData?.longDescription}
                setEditorContent={(value) =>
                  handleEditorChange(value, "longDescription")
                }
              />
            </Form.Group>
          </Col>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={handleSubmit}>
              {mode === "add" ? "Add New" : "Update"}
            </Button>
          </div>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default ServicesSection;
